module.exports = __webpack_public_path__ + "static/media/clubs.09b403b6.svg";